import { jsx as w } from "react/jsx-runtime";
import "react";
import { classNames as n } from "../../utilities/index.js";
const d = _ref => {
    let {
      xs: l,
      sm: f,
      md: a,
      lg: u,
      xl: i,
      xxl: m,
      children: e,
      className: t,
      ...o
    } = _ref;
    const x = n({
      "sash-Column relative min-w-0": !0,
      [`flex-${l}/12 max-w-${l}/12`]: l && l !== "fluid" && l !== "auto",
      "flex-1 max-w-full": l === "fluid" || !l,
      "flex-initial max-w-full": l === "auto",
      [`sm:flex-${f}/12 sm:max-w-${f}/12`]: f && f !== "fluid" && f !== "auto",
      "sm:flex-1 sm:max-w-full": f === "fluid",
      "sm:flex-initial sm:max-w-full": f === "auto",
      [`md:flex-${a}/12 md:max-w-${a}/12`]: a && a !== "fluid" && a !== "auto",
      "md:flex-1 md:max-w-full": a === "fluid",
      "md:flex-initial md:max-w-full": a === "auto",
      [`lg:flex-${u}/12 lg:max-w-${u}/12`]: u && u !== "fluid" && u !== "auto",
      "lg:flex-1 lg:max-w-full": u === "fluid",
      "lg:flex-initial lg:max-w-full": u === "auto",
      [`xl:flex-${i}/12 xl:max-w-${i}/12`]: i && i !== "fluid" && i !== "auto",
      "xl:flex-1 xl:max-w-full": i === "fluid",
      "xl:flex-initial xl:max-w-full": i === "auto",
      [`2xl:flex-${m}/12 2xl:max-w-${m}/12`]: m && m !== "fluid" && m !== "auto",
      "2xl:flex-1 2xl:max-w-full": m === "fluid",
      "2xl:flex-initial 2xl:max-w-full": m === "auto",
      [t]: t
    });
    return /* @__PURE__ */w("div", {
      className: x,
      ...o,
      children: e
    });
  },
  c = d;
export { c as default };